// ============================================================
// ブログ記事：本文の「【目次】」から見出しリンクを生成
// ============================================================

(() => {
  const ARTICLE_BODY_SELECTOR = '[data-section-type="article"] > .rte';
  const MARKER_TEXT = '【目次】';
  const MARKER_BLOCK_SELECTOR = 'p, div, section';
  const TARGET_HEADING_SELECTOR = [
    'h2',
    'h3',
    'section.xot-toggle--heading.xot-toggle--h2 > .xot-toggle__heading',
    'section.xot-toggle--heading.xot-toggle--h3 > .xot-toggle__heading'
  ].join(',');
  const TARGET_ID_PREFIX = 'kugui-article-toc-heading-';
  let nextHeadingNumber = 0;

  function isTocMarker(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, '')
      .trim() === MARKER_TEXT;
  }

  function getMarkers(articleBody) {
    const blocks = Array.from(
      articleBody.querySelectorAll(MARKER_BLOCK_SELECTOR)
    ).filter((element) => {
      if (!isTocMarker(element.textContent)) return false;

      return !Array.from(
        element.querySelectorAll(MARKER_BLOCK_SELECTOR)
      ).some((child) => isTocMarker(child.textContent));
    });

    const textNodes = Array.from(articleBody.childNodes).filter(
      (node) => node.nodeType === Node.TEXT_NODE &&
        isTocMarker(node.textContent)
    );

    return blocks.concat(textNodes).sort((a, b) => {
      if (a === b) return 0;
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING
        ? -1
        : 1;
    });
  }

  function getHeadingLevel(heading) {
    if (heading.matches('h2, h3')) {
      return heading.tagName.toLowerCase();
    }

    return heading.parentElement.classList.contains('xot-toggle--h3')
      ? 'h3'
      : 'h2';
  }

  function getHeadingsAfter(articleBody, marker) {
    return Array.from(
      articleBody.querySelectorAll(TARGET_HEADING_SELECTOR)
    ).filter((heading) => {
      if (heading.closest('.kugui-article-toc')) return false;

      // プレビュー見出しの内側にある h2/h3 は親の見出しと重複させない。
      const previewHeading = heading.closest('.xot-toggle__heading');
      if (previewHeading && previewHeading !== heading &&
          previewHeading.parentElement?.matches('section.xot-toggle--heading')) {
        return false;
      }

      return Boolean(
        marker.compareDocumentPosition(heading) &
          Node.DOCUMENT_POSITION_FOLLOWING
      );
    });
  }

  function ensureHeadingId(heading) {
    if (heading.id) {
      const sameIdCount = Array.from(
        document.querySelectorAll('[id]')
      ).filter((element) => element.id === heading.id).length;

      if (sameIdCount === 1) {
        heading.dataset.kuguiTocTargetId = heading.id;
        return heading.id;
      }
    }

    let id;
    do {
      nextHeadingNumber += 1;
      id = TARGET_ID_PREFIX + nextHeadingNumber;
    } while (document.getElementById(id));

    heading.id = id;
    heading.dataset.kuguiTocTargetId = id;
    return id;
  }

  function buildToc(headings) {
    if (!headings.length) return null;

    const nav = document.createElement('nav');
    nav.className = 'kugui-article-toc';
    nav.setAttribute('aria-label', '目次');

    const title = document.createElement('div');
    title.className = 'kugui-article-toc__title';
    title.textContent = '目次';

    const list = document.createElement('ul');
    list.className = 'kugui-article-toc__list';

    headings.forEach((heading) => {
      const item = document.createElement('li');
      item.className = 'kugui-article-toc__item kugui-article-toc__item--' +
        getHeadingLevel(heading);

      const link = document.createElement('a');
      link.className = 'kugui-article-toc__link';
      link.href = '#' + ensureHeadingId(heading);
      link.textContent = heading.textContent.trim();

      item.appendChild(link);
      list.appendChild(item);
    });

    nav.appendChild(title);
    nav.appendChild(list);
    return nav;
  }

  function initArticleToc(articleBody) {
    getMarkers(articleBody).forEach((marker) => {
      if (!marker.isConnected) return;

      const toc = buildToc(getHeadingsAfter(articleBody, marker));
      if (toc) {
        marker.replaceWith(toc);
      } else {
        marker.remove();
      }
    });
  }

  function initKuguiArticleToc(root = document) {
    if (root.nodeType === 1 && root.matches?.(ARTICLE_BODY_SELECTOR)) {
      initArticleToc(root);
    }

    root.querySelectorAll?.(ARTICLE_BODY_SELECTOR).forEach(initArticleToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initKuguiArticleToc(),
      { once: true }
    );
  } else {
    initKuguiArticleToc();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initKuguiArticleToc(event.target);
  });
})();
